import { LOCALES } from 'i18n/locales';

export const bookmarkPageIntl = {
    [LOCALES.ENGLISH]: {
        'bookmarkPage.title': 'Bookmarks',
        'bookmarkPage.items': 'items',
        'bookmarkPage.bookmarksDeleted': 'Bookmark(s) Deleted',
        'bookmarkPage.name': 'Name',
        'bookmarkPage.type': 'Type',
        'bookmarkPage.dateModified': 'Date Modified',
        'bookmarkPage.viewBookmark': 'View Bookmark',
        'bookmarkPage.share': 'Share'
    },
    [LOCALES.WELSH]: {
        'bookmarkPage.title': 'Nodau tudalen',
        'bookmarkPage.items': 'eitemau',
        'bookmarkPage.bookmarksDeleted': 'Nod(au) Tudalen wedi\'u dileu',
        'bookmarkPage.name': 'Enw',
        'bookmarkPage.type': 'Math',
        'bookmarkPage.dateModified': 'Dyddiad y\'i Diwygiwyd:',
        'bookmarkPage.viewBookmark': 'Gweld Nod Tudalen',
        'bookmarkPage.share': 'Rhannu'
    }
};
